import { defineStore } from 'pinia'

import type { SettingsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsStore => ({
    settings: null,
    _hydrated: false,
    _initialLoaded: false,
  }),
  actions,
  getters,
})
